  
  function posicionaPagina(ancora) {
        setTimeout(() => {
        // só executa se a mensagemErro estiver vazia
              if (this.mensagemErro && this.mensagemErro.length > 0) {
                window.scrollTo(0, 0);
                return;
              }
              const posicionaAncora = document.querySelector(ancora);
              if (posicionaAncora) {
                posicionaAncora.scrollIntoView({ behavior: 'smooth' })
              }
         }, 300);   
    }

 module.exports = {
  posicionaPagina
}